import { personMachine } from '~domains/profile/entities/person';

import { StateValueFrom } from 'xstate';

type PersonStateValue = StateValueFrom<typeof personMachine>;
type PersonStepState = Extract<PersonStateValue, string>;

export const PROFILE_NAV_STEPS = {
  basicInfo: 'basicInfo',
  address: 'currentAddress',
  idDocument: 'idDocument',
  selfie: 'selfie',
} as const satisfies Record<string, PersonStepState>;

export type ProfileNavStepId =
  (typeof PROFILE_NAV_STEPS)[keyof typeof PROFILE_NAV_STEPS];
